export interface TreeKey {
	category: string;
	id: number;
}

export class ExpansionCache {
	private expanded: TreeKey[];

	constructor(query: string | null | (string | null)[]) {
		this.expanded = [];
		if (Array.isArray(query)) {
			for (const item of query) {
				try {
					const parsed = parse(item ?? '');
					if (parsed !== null) {
						this.expanded.push(parsed);
					}
				} catch {
					continue;
				}
			}
		} else if (typeof query === 'string') {
			try {
				const parsed = parse(query);
				if (parsed !== null) {
					this.expanded.push(parsed);
				}
			} catch {
				this.expanded = [];
			}
		}
	}

	add(key: TreeKey): void {
		if (!this.contains(key)) {
			this.expanded = [...this.expanded, key];
		}
	}

	remove(key: TreeKey): void {
		this.expanded = this.expanded.filter((i) => i.category !== key.category || i.id !== key.id);
	}

	contains(key: TreeKey): boolean {
		return this.expanded.some((i) => i.category === key.category && i.id === key.id);
	}

	get queryParams(): string[] {
		return this.expanded.map((i) => `${i.category}:${i.id}`);
	}
}

function parse(item: string): TreeKey | null {
	const [category, id] = item.split(':');
	const parsed = parseInt(id);
	if (!isNaN(parsed)) {
		return { category, id: parseInt(id) };
	}
	return null;
}
